import React from 'react'
import clsx from 'clsx'

import Typography, { TypographyProps } from 'components/Typography'

import stylesGlobal from 'stylesGlobal.module.scss'
import styles from './Chip.module.scss'

export type ChipProjectLabelProps = {
  children?: React.ReactNode
  className?: string
  color?: 'blue' | 'magenta'
  component?: 'div' | 'span'
  variant?: TypographyProps['variant']
}

const ChipProjectLabel: React.FC<ChipProjectLabelProps> = props => {
  const {
    children,
    className,
    color = 'blue',
    component: Component = 'div',
    variant = 'body1'
  } = props

  return (
    <Typography
      className={clsx(
        styles.ChipProjectLabel,
        stylesGlobal.PaddingY4,
        stylesGlobal.PaddingX14,
        color === 'blue' && styles.BgColorBlue,
        color === 'magenta' && styles.BgColorMagenta,
        className
      )}
      component={Component}
      variant={variant}
    >
      {children}
    </Typography>
  )
}

export default ChipProjectLabel
